import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import orderBy from 'lodash/orderBy';
import { injectIntl, intlShape } from 'react-intl';
import AssignCourseConquest from '../../components/assign-course-conquest';
import classEnum from '../class-roll/constants';
import * as actionTypes from './action-types';
import { DEFAULT_COUNTRY_ID, DEFAULT_COURSE_ID, DEFAULT_YEAR_GROUP } from '../../constants';

class AssignCoursesConquest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: '',
            filteredCourses: [],
            selectedYearGroupId: '-1',
            selectedCountryId: '-1',
            yearGroups: [],
            initialLoad: true
        };

        this.countries = [];
        this.selectedCourse = { id: -1, name: '' };
        this.selectedCountryId = '-1';
    }

    componentDidMount() {
        const { selectedProduct, dispatch } = this.props;
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ countryLoading: true }, () => {
            dispatch({ type: actionTypes.GET_CONQUEST_COUNTRY_REQUEST, selectedProductId: selectedProduct.id });
        });
    }

    componentWillReceiveProps(nextProps) {
        const { yearGroups, countries, courses, deselectCourse } = nextProps;

        this.countries = countries;
        this.selectedCourse = nextProps.selectedCourse;

        if (this.props.courses !== courses) {
            if (this.selectedCountryId === classEnum.SCHOOL_COURSES) {
                this.updateCourseSelection(courses);
            } else {
                this.updateCourseSelection(orderBy(courses, ['isDefault'], ['desc']));
            }
        }

        if (deselectCourse) {
            this.clearSelectedCourse(yearGroups);
        } else {
            this.setState({ yearGroups });
        }
    }

    clearSelectedCourse = (yearGroups) => {
        const { dispatch } = this.props;
        const filteredCourses = this.state.filteredCourses.map(course => ({
            ...course,
            isSelected: false
        }));
        this.setState({ filteredCourses, yearGroups });
        dispatch({ type: actionTypes.DESELECT_COURSE, deselectCourse: false });
    }

    handleOnCountryChange = (name, selectedCountryId) => {
        const { dispatch } = this.props;
        this.selectedCountryId = selectedCountryId;

        this.setState({
            selectedCountryId,
            selectedYearGroupId: '-1',
            filteredCourses: [],
            searchQuery: ''
        });

        if (selectedCountryId !== '-1' && selectedCountryId !== classEnum.SCHOOL_COURSES) {
            dispatch(
                {
                    type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST,
                    countryCode: selectedCountryId,
                    countryCourses: []
                }
            );
        }

        if (selectedCountryId === classEnum.SCHOOL_COURSES) {
            dispatch({ type: actionTypes.GET_YEAR_GROUP_REQUEST });
        }

        dispatch({ type: actionTypes.CLEAR_COURSE_LIST, productCourses: [] });
        this.selectedCourse = { id: '-1', name: '' };
        this.props.handleOnCourseSelection(this.selectedCourse, true);
    }

    handleOnYearGroupChange = (name, selectedYearGroupId) => {
        const { selectedProduct, dispatch } = this.props;

        this.setState({ selectedYearGroupId, initialLoad: false, searchQuery: '' });

        if (selectedYearGroupId !== '-1') {
            dispatch({
                type: actionTypes.GET_FILTERED_CONQUEST_COURSES_REQUEST,
                countryCode: this.selectedCountryId,
                productId: selectedProduct.id,
                yearGroup: selectedYearGroupId,
                isProductCoursesLoaded: false,
                isProductCoursesFetching: true,
                selectGenericCourses: false,
                includeGlobalCourses: true
            });
        } else {
            this.updateCourseSelection();
        }

        this.selectedCourse = { id: '-1', name: '' };
        this.props.handleOnCourseSelection(this.selectedCourse, true);
    }

    handleOnSearchCourse = (e) => {
        const { courses } = this.props;
        const currentCourses = courses;
        let courseFilter = [];

        if (this.selectedCountryId === classEnum.SCHOOL_COURSES) {
            courseFilter = currentCourses;
        } else {
            courseFilter = orderBy(currentCourses, ['isDefault'], ['desc']);
        }
        const filteredCourses = courseFilter.filter(course =>
            course.name.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1);

        if (!filteredCourses.length) {
            this.selectedCourse = { id: '-1', name: '' };
            this.props.handleOnCourseSelection(this.selectedCourse, true);
        }

        this.setState({ searchQuery: e.target.value });
        this.updateCourseSelection(filteredCourses);
    }

    handleOnCourseSelection = (course) => {
        this.selectedCourse = course;
        this.updateCourseSelection(this.state.filteredCourses);
        this.props.handleOnCourseSelection(course);
    }

    assignToYearGroup = () => {
        this.props.handleOnYearGroupSave(this.selectedCourse);
        this.clearSelectedCourse();
    }

    handleOptOutOfCourse = () => {
        this.selectedCourse = { id: DEFAULT_COURSE_ID, name: '' };
        this.props.handleOnCourseSelection(this.selectedCourse);
        this.props.handleOnYearGroupSave(this.selectedCourse);
        this.clearSelectedCourse(this.state.yearGroups);
    }

    updateCourseSelection = (courses = []) => {
        const filteredCourses = courses.map((course) => {
            let isSelected = false;
            if (this.selectedCourse && (course.name.toLowerCase() === this.selectedCourse.name.toLowerCase())) {
                isSelected = true;
            }
            return {
                ...course,
                isSelected
            };
        });
        this.setState({ filteredCourses });
    }

    disableYearGroup = () => this.selectedCountryId === DEFAULT_COUNTRY_ID

    disableSearchCourse = () => {
        const { selectedYearGroupId } = this.state;
        return this.selectedCountryId === DEFAULT_COUNTRY_ID || selectedYearGroupId === DEFAULT_YEAR_GROUP;
    }

    render() {
        const {
            filteredCourses,
            initialLoad,
            searchQuery,
            selectedYearGroupId,
            yearGroups
        } = this.state;

        return (
            <AssignCourseConquest
                disableAssignToYear={this.state.selectedYearGroupId === '-1' || this.state.selectedCountryId === DEFAULT_COUNTRY_ID || this.selectedCourse.id === DEFAULT_COURSE_ID}
                disableSearch={this.disableSearchCourse()}
                disableYearGroup={this.disableYearGroup()}
                filteredCourses={filteredCourses}
                forLegacy={this.state.legacy}
                handleOnCountryChange={this.handleOnCountryChange}
                handleOnSearchCourse={this.handleOnSearchCourse}
                handleOnYearGroupChange={this.handleOnYearGroupChange}
                initialLoad={initialLoad}
                searchQuery={searchQuery}
                selectedYearGroupId={selectedYearGroupId}
                yearGroups={yearGroups}
                {...this.props}
                assignToYearGroup={this.assignToYearGroup}
                countries={this.props.conquestCountries}
                handleOnCourseSelection={this.handleOnCourseSelection}
                handleOptOutOfCourse={this.handleOptOutOfCourse}
                selectedCountryId={this.selectedCountryId} />
        );
    }
}

AssignCoursesConquest.propTypes = {
    intl: intlShape.isRequired,
    selectedProduct: PropTypes.object,
    countries: PropTypes.array,
    conquestCountries: PropTypes.array,
    courses: PropTypes.array,
    yearGroups: PropTypes.array,
    selectedCourse: PropTypes.object,
    isProductCoursesLoaded: PropTypes.bool,
    isSchoolCoursesLoaded: PropTypes.bool,
    isNewCoursesLoaded: PropTypes.bool,
    deselectCourse: PropTypes.bool,
    handleOnCourseSelection: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    handleOnYearGroupSave: PropTypes.func,
    isNewCoursesSelected: PropTypes.bool,
    newCourses: PropTypes.array,
    showAssignSuccessToast: PropTypes.bool,
    showAssignErrorToast: PropTypes.bool,
    showToast: PropTypes.func
};

function mapStateToProps(state = {}) {
    return {
        ...state,
        yearGroups: state.assignConquestCourses.yearGroups,
        countries: state.assignConquestCourses.countries,
        conquestCountries: state.assignConquestCourses.conquestCountries,
        courses: state.assignConquestCourses.filteredCourses,
        newCourses: state.classRoll.newCourses,
        isNewCoursesLoaded: state.classRoll.isProductCoursesLoaded,
        deselectCourse: state.assignConquestCourses.deselectCourse,
        isLoadingCountryYearGroups: state.assignConquestCourses.isLoadingCountryYearGroups,
        isProductCoursesLoaded: state.assignConquestCourses.isProductCoursesLoaded,
        isSchoolCoursesLoaded: state.assignConquestCourses.isSchoolCoursesLoaded,
        isCourseModalVisible: state.defaultCourses.isCourseModalVisible,
        courseDetails: state.defaultCourses.courseDetails,
        fetchingCourse: state.defaultCourses.fetchingCourse,
        selectedProduct: state.product,
        showAssignSuccessToast: state.assignCourseAdmin.showAssignSuccessToast,
        showAssignErrorToast: state.assignCourseAdmin.showAssignErrorToast
    };
}

export default injectIntl(connect(mapStateToProps)(AssignCoursesConquest));



// WEBPACK FOOTER //
// ./app/containers/assign-courses-conquest/index.js